import { IWarehousePayload } from "interfaces/Index";

export const defaultWarehouse: IWarehousePayload = {
  id: "",
  name: "",
  latitude: 0.0,
  longitude: 0.0,
};
